<template>
  <section class="block">
    <label class="label">Professional headline / position (optional)</label>
    <input
      v-model="model"
      type="text"
      class="input"
      maxlength="200"
      placeholder="e.g. DATA ANALYST | DÉVELOPPEUR BI | AUTOMATISMES IA"
    />
    <span class="hint">{{ model.length }}/200</span>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({ modelValue: { type: String, default: '' } });
const emit = defineEmits(['update:modelValue']);

const model = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v ?? '')
});
</script>

<style scoped>
.block { margin-bottom: 0; }
.label { display: block; font-weight: 600; margin-bottom: 0.35rem; color: var(--text-primary); }
.input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  background: #ffffff;
  color: var(--text-primary);
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.input::placeholder { color: var(--text-muted); opacity: 1; }
.input:hover:not(:disabled) { border-color: var(--input-border-hover, var(--border)); }
.input:focus {
  outline: none;
  border-color: var(--focus-ring);
  box-shadow: 0 0 0 2px var(--focus-ring);
}
.hint { font-size: 0.8rem; color: var(--text-secondary); }
</style>
